import { onCleanup, onMount } from 'solid-js'

import createEmblaCarousel from 'embla-carousel-solid'
import { A, useNavigate } from '@solidjs/router'

const HomeSpotlight = () => {
  const HomesContent = [
    {
      realName: 'Candice Nice',
      text: "With her infectious energy and impeccable attention to detail, she brings the iconic character to life in a whirlwind ofcolor and chaos. From her playful demeanor to her penchant formischief, Candice captivates audiences with her boundlessenthusiasm for embodying Gotham's most enigmatic villainess...",
      link: '/model/harley-quinn/candice-nice',
      bg: '/images/home/home-1/bg.webp',
      bgSmall: '/images/home/home-1/bg-small.webp',
      realNameStyle: 'text-[28px]',
      bgPosition: 'bg-homePosOne bg-homeSizOne xs:bg-[76%] lg:bg-center',
      nameLogo: '/images/home/home-1/name-logo.webp',
      galleryOne: '/images/home/home-1/gallery-1.webp',
      galleryTwo: '/images/home/home-1/gallery-2.webp',
      nameLogoPosition:
        'py-3 max-w-[195px] xs:max-w-[55vw] lg:max-w-[500px] left-[85%] bottom-[35%]',
    },
    {
      realName: 'Molly Love',
      text: "Hey everyone, I'm Molly Love, and I'm all about embracing the magic of cosplay! One of my absolute favorite transformations is stepping into the world of Barbie - her elegance and style just captivates me. I have a huge passion for diving into various cosplay characters too. From fierce warriors to beloved fantasy icons...",
      link: '/model/barbie/molly-love',
      bg: '/images/home/home-2/bg.webp',
      bgSmall: '/images/home/home-2/bg-small.webp',
      realNameStyle: 'text-[32px]',
      bgPosition: 'bg-homePosTwon bg-homeSizTwo xs:bg-[91.5%_80%] lg:bg-center',
      nameLogo: '/images/home/home-2/name-logo.webp',
      galleryOne: '/images/home/home-2/gallery-1.webp',
      galleryTwo: '/images/home/home-2/gallery-2.webp',
      nameLogoPosition:
        'pt-6 pb-8 max-w-[187px] xs:max-w-[55vw] lg:max-w-[400px] left-[69%] bottom-[55%]',
    },
    {
      realName: 'Crystal Viv',
      text: "Hey everyone, I'm Crystal Viv, and I'm all about diving into the world of cosplay! One of my all-time favorite characters to become is Catwoman - her sexy and seductive vibe turns me on so much! From powerful characters to those with a touch of allure, I find joy in bringing them to life. Join me as I explore the fun and creativity of cosplay...",
      link: '/model/catwoman/crystal-viv',
      bg: '/images/home/home-3/bg.webp',
      bgSmall: '/images/home/home-3/bg-small.webp',
      realNameStyle: 'text-[32px]',
      bgPosition: 'bg-homePosThree bg-homeSizThree xs:bg-[72%] lg:bg-center',
      nameLogo: '/images/home/home-3/name-logo.webp',
      galleryOne: '/images/home/home-3/gallery-1.webp',
      galleryTwo: '/images/home/home-3/gallery-2.webp',
      nameLogoPosition:
        'pt-6 pb-20 max-w-[218px] xs:max-w-[55vw] lg:max-w-[438px] left-[70%] bottom-[61.75%]',
    },
    {
      realName: 'August Bloom',
      text: "Hi, I'm August Bloom, and I'm all about the magic of cosplay! One of my absolute favorite characters to embody is Poison Ivy because her fierce and enchanting presence drives my fans wild! Stepping into her shoes is like bringing a touch of wild elegance to life. Exploring the world of cosplay allows me to tap into my creativity and transform into...",
      link: '/model/poison-ivy/august-bloom',
      bg: '/images/home/home-4/bg.webp',
      bgSmall: '/images/home/home-4/bg-small.webp',
      realNameStyle: 'text-[32px]',
      bgPosition: 'bg-homePosFour bg-homeSizFour xs:bg-[80%] lg:bg-center',
      nameLogo: '/images/home/home-4/name-logo.webp',
      galleryOne: '/images/home/home-4/gallery-1.webp',
      galleryTwo: '/images/home/home-4/gallery-2.webp',
      nameLogoPosition:
        'pt-7 py-10 max-w-[215px] xs:max-w-[55vw] lg:max-w-[335px] left-[70%] bottom-[58%]',
    },
    {
      realName: 'Riley Ru',
      text: "Hi there, I'm Riley Ru, and I'm all about embracing the world of cosplay!  You might often find me channeling my inner Chun-Li from Street Fighter - her strength and grace really resonate with me. I also have a passion for bringing some sexy energy to my cosplays....",
      link: '/model/chun-li/riley-ru',
      bg: '/images/home/home-5/bg.webp',
      bgSmall: '/images/home/home-5/bg-small.webp',
      realNameStyle: 'text-[32px]',
      bgPosition: 'bg-homePosFive bg-homeSizFive xs:bg-[81%] lg:bg-center',
      nameLogo: '/images/home/home-5/chun-li-logo-4x.png',
      galleryOne: '/images/home/home-5/gallery-1.webp',
      galleryTwo: '/images/home/home-5/gallery-2.webp',
      nameLogoPosition:
        'pt-6 pb-14 max-w-[150px] xs:max-w-[55vw] lg:max-w-[370px] left-[62%] bottom-[53%]',
    },
  ]

  const nav = useNavigate()

  const [emblaRef, emblaApi] = createEmblaCarousel(
    () => ({ loop: true, speed: 10, containScroll: 'trimSnaps' })
    // () => [Autoplay({ delay: 2500 })]
  )

  let autoplayInterval: ReturnType<typeof setInterval> | null = null
  // Autoplay function to automatically scroll to the next slide
  const autoplay = () => {
    if (emblaApi()) {
      autoplayInterval = setInterval(() => {
        emblaApi()?.scrollNext()
      }, 3000) // Auto-scroll every 3 seconds
    }
  }

  // Reset autoplay timer
  const resetAutoplay = () => {
    if (autoplayInterval) {
      clearInterval(autoplayInterval) // Clear the existing autoplay timer
    }
    autoplay() // Start autoplay again
  }

  onMount(() => {
    autoplay() // Start autoplay when the component mounts
    emblaApi()?.on('pointerDown', resetAutoplay)
  })

  onCleanup(() => {
    emblaApi()?.destroy()
  })

  // Handlers for next and previous buttons
  const scrollNext = () => {
    emblaApi()?.scrollNext()
    resetAutoplay()
  }

  const scrollPrev = () => {
    emblaApi()?.scrollPrev()
    resetAutoplay()
  }

  return (
    <main class="home relative">
      <div class="embla">
        <div class="embla__viewport" ref={emblaRef}>
          <div class="embla__container">
            {HomesContent.map((item) => (
              <div
                style={{
                  'background-image': `url(${screen.width < 1024 ? item.bgSmall : item.bg})`,
                }}
                class={`slide embla__slide max-h-[665px]f xs:max-h-nonef h-[calc(100svh-50px)] overflow-hidden !bg-cover bg-no-repeat pb-16 pt-28 xs:pt-32 sm:pb-0 sm:pt-36 md:min-h-screen lg:min-h-[971px] ${item.bgPosition}`}
              >
                <div class="container">
                  <div class="wrapper">
                    <div class="content flex flex-col items-start">
                      <div class="top relative flex flex-col items-start leading-none">
                        <h3 class="text-base font-semibold text-cyan sm:text-2xl md:text-3xl">
                          FEATURED CREATOR
                        </h3>
                        <h2
                          class={`mt-2 font-bold leading-none sm:mt-6 sm:text-5xl md:text-[56px] ${item.realNameStyle}`}
                        >
                          {item.realName}{' '}
                          <span class="text-base font-medium xs:text-xl sm:text-5xl sm:font-bold md:text-[56px]">
                            as
                          </span>
                        </h2>
                        {/* pera */}
                        <div class="pera mt-10 hidden w-full max-w-[37.75rem] text-xl font-medium md:block">
                          {item.text}
                          <span class="read-more text-red">Read More</span>
                        </div>
                        <div class="min-h-16 sm:min-h-[inherit] xl:h-[inherit]">
                          <img
                            class={`sm:h-[inherit] sm:w-full xl:absolute ${item.nameLogoPosition}`}
                            src={item.nameLogo}
                            alt="svg"
                          />
                        </div>
                      </div>

                      {/* middle */}
                      <div class="middle text-lg font-semibold xs:mt-6 sm:text-[22px]">
                        <div class="desktop hidden gap-6 sm:grid">
                          <div class="item flex items-center gap-2 sm:gap-4">
                            <img class="h-[26px]" src="/images/icons/flame.svg" alt="flame" />
                            <h4>Subscribe and gain ACCESS to daily uploaded content!</h4>
                          </div>
                          <div class="item flex items-center gap-2 sm:gap-4">
                            <img class="h-[26px]" src="/images/icons/flame.svg" alt="flame" />
                            <h4>Live Messaging 24/7!</h4>
                          </div>
                        </div>
                        {/* mobile */}
                        <div class="mobile grid gap-3 sm:hidden">
                          <div class="item flex items-center gap-2 sm:gap-4">
                            <img class="h-[26px]" src="/images/icons/flame.svg" alt="flame" />
                            <h4>VIP Content</h4>
                          </div>
                          <div class="item flex items-center gap-2 sm:gap-4">
                            <img class="h-[26px]" src="/images/icons/flame.svg" alt="flame" />
                            <h4>Live Chat 24/7</h4>
                          </div>
                          <div class="item flex items-center gap-2 sm:gap-4">
                            <img class="h-[26px]" src="/images/icons/flame.svg" alt="flame" />
                            <h4>Generate Custom Content!</h4>
                          </div>
                        </div>
                      </div>

                      {/* registration btn */}
                      <div class="btn flex pt-7">
                        <button
                          class="registration-btn relative flex h-[56px] w-[175px] items-center justify-center rounded-xl border border-white text-base font-semibold ring-[3px] ring-transparent transition-all duration-300  before:absolute before:inset-0 before:-z-0 before:rounded-xl before:bg-gradient-to-r before:from-secondary before:to-primary before:transition-all before:duration-300 hover:ring-secondary hover:before:opacity-50 sm:w-[209px]"
                          onClick={() => nav(item.link)}
                        >
                          <span class="relative">View Profile</span>
                        </button>
                      </div>
                      {/* gallery */}
                      <div class="gallery mt-9 hidden grid-cols-2 gap-9 md:grid">
                        <A href={item.link}>
                          <img
                            class="h-full max-h-[232px] w-full max-w-[350px] rounded-xl"
                            src={item.galleryOne}
                            alt="gallery-1"
                          />
                        </A>
                        <A href={item.link}>
                          <img
                            class="h-full max-h-[232px] w-full max-w-[350px] rounded-xl"
                            src={item.galleryTwo}
                            alt="gallery-2"
                          />
                        </A>
                      </div>

                      {/* see profile */}
                      <A
                        href={item.link}
                        class="see-profile hidden items-center gap-1 py-7 text-base text-[#FF0000] sm:flex"
                      >
                        <span> See profile</span>{' '}
                        <svg
                          fill="#FF0000"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"></path>
                        </svg>
                      </A>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div class="arrows absolute bottom-10 right-8 flex items-center gap-4 fill-white xs:bottom-32">
        <div
          onClick={scrollPrev}
          class="left embla__prev left-3 top-1/2 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full bg-primary/60 shadow-2xl backdrop-blur-2xl transition-all duration-300 hover:bg-primary sm:h-8 sm:w-8 md:absolute md:h-10 md:w-10"
        >
          <svg
            class="h-4 w-4 sm:h-6 sm:w-6 md:h-8 md:w-8"
            stroke-width="0"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"></path>
          </svg>
        </div>
        <div class="right embla__next right-3 top-1/2 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full bg-primary/60 shadow-2xl backdrop-blur-2xl transition-all duration-300 hover:bg-primary sm:h-8 sm:w-8 md:absolute md:h-10 md:w-10">
          <svg
            class="h-4 w-4 sm:h-6 sm:w-6 md:h-8 md:w-8"
            onClick={scrollNext}
            stroke-width="0"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"></path>
          </svg>
        </div>
      </div>
    </main>
  )
}

export default HomeSpotlight
